import { useLanguage } from "@/hooks/useLanguage";
import { Button } from "@/components/ui/button";
import { Coffee, Heart, ArrowRight } from "lucide-react";

const Support = () => {
  const { t } = useLanguage();

  return (
    <section id="support" className="py-24 px-6 bg-muted/30">
      <div className="max-w-3xl mx-auto">
        <div className="relative rounded-xl overflow-hidden bg-foreground text-background p-8 md:p-12 text-center">
          {/* Subtle pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[length:24px_24px]" />
          </div>

          <div className="relative">
            <h2 className="text-2xl md:text-3xl font-semibold mb-4">
              {t('supportTitle') || 'Support the Development'}
            </h2>
            <p className="text-background/70 max-w-lg mx-auto mb-8">
              {t('supportSubtitle') || 'PhoneticPro is free and open source. Your support helps keep it that way.'}
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button 
                size="lg" 
                className="gap-2 bg-background text-foreground hover:bg-background/90"
                asChild
              >
                <a 
                  href="https://www.patreon.com/cemates/membership" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Heart className="h-4 w-4" />
                  {t('supportPatreon') || 'Support on Patreon'}
                  <ArrowRight className="h-4 w-4" />
                </a>
              </Button>
              
              <Button 
                size="lg" 
                variant="ghost"
                className="gap-2 border border-background/40 text-background/90 hover:bg-background/20 hover:text-background"
                asChild
              >
                <a 
                  href="https://www.buymeacoffee.com/cemates" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Coffee className="h-4 w-4" />
                  {t('supportBuyMeACoffee') || 'Buy Me a Coffee'}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
